import { doc, setDoc } from "firebase/firestore";
import { db } from "../utils/init-firebase";

const SESSION_LISTENER_COLLECTION_NAME = "session_listener";

export const updateSessionListener = async (id: string, objectWithChange: any) => {
  const userDoc = doc(db, `${SESSION_LISTENER_COLLECTION_NAME}`, id);

  await setDoc(userDoc, objectWithChange, { merge: true })
    .then(() => {
      // console.log("User session listener has been updated");
    })
    .catch((err) => {
      // console.log("Error: User session listener failed to update: ", err);
    });
};
